import { FC, useState } from 'react';

import { TransportPlan } from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { hasRelayPointApi } from '@savgroup-front-common/core/api/Claim/helpers/hasRelayPointApi';
import { StrictAutocompleteOption } from '@savgroup-front-common/types';

import { HandlingValues, PickupPointOption } from '../../../../IrshPages.types';

import PickupPointSelector from './PickupPointSelector';
import { usePickupPointOptions } from './SelectPickupPointDrawerContent.hooks';

interface SelectPickupPointDrawerContentProps {
  onSetPickupPoint: ({
    pickupPoint,
  }: {
    pickupPoint: PickupPointOption;
  }) => void;
  availableMethod: StrictAutocompleteOption<TransportPlan[]>;
  defaultSearchAddress?: {
    address?: string;
    countryCode?: string;
    postalCode?: string;
    city?: string;
  };
  selectedPickupPoint?: PickupPointOption;
  onClose: () => void;
  handlingValues: HandlingValues;
  isImmediateDropAtStoreMethod: boolean;
  onSelectTransportPlanWithoutRelayPointApi?: (
    transportPlan: TransportPlan,
  ) => void;
}

export const SelectPickupPointDrawerContent: FC<
  SelectPickupPointDrawerContentProps
> = ({
  onSetPickupPoint,
  availableMethod,
  defaultSearchAddress,
  selectedPickupPoint,
  onClose,
  handlingValues,
  isImmediateDropAtStoreMethod,
  onSelectTransportPlanWithoutRelayPointApi,
}) => {
  const [searchAddress, setSearchAddress] = useState<
    | {
        address?: string;
        countryCode?: string;
        postalCode?: string;
        city?: string;
      }
    | undefined
  >(defaultSearchAddress);
  const {
    pickupPoints,
    transportPlansWithoutRelayPointApi,
    isLoading: isPickupPointsLoading,
  } = usePickupPointOptions({
    searchAddress,
    availableMethod,
    isDropAtStore: true,
  });
  const hasTransportPlanWithRelayPointApi =
    availableMethod.data.some(hasRelayPointApi);

  return (
    <PickupPointSelector
      maxDistance={200}
      pickupPoints={pickupPoints ?? []}
      selectedPickupPoint={selectedPickupPoint}
      onSelectPickupPoint={(pickupPoint: PickupPointOption) =>
        onSetPickupPoint({
          pickupPoint,
        })
      }
      searchAddress={searchAddress}
      onAddressSelected={(addressSelected) => setSearchAddress(addressSelected)}
      onClose={onClose}
      pickupPointsIsLoading={isPickupPointsLoading}
      handlingValues={handlingValues}
      isImmediateDropAtStoreMethod={isImmediateDropAtStoreMethod}
      transportPlansWithoutRelayPointApi={transportPlansWithoutRelayPointApi}
      hasTransportPlanWithRelayPointApi={hasTransportPlanWithRelayPointApi}
      onSelectTransportPlanWithoutRelayPointApi={
        onSelectTransportPlanWithoutRelayPointApi
      }
    />
  );
};
